// Tag colors are arbitrary user-picked hex values; pick black/white text by luminance.
export function readableTextColor(hex: string): string {
  const value = hex.replace('#', '');
  const full =
    value.length === 3
      ? value
          .split('')
          .map(c => c + c)
          .join('')
      : value;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return '#000000';
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? '#000000' : '#ffffff';
}

/** NTag `color` prop object for a tag chip, or undefined for the default look. */
export function tagChipColor(
  color: string | null | undefined
): { color: string; textColor: string; borderColor: string } | undefined {
  return color ? { color, textColor: readableTextColor(color), borderColor: color } : undefined;
}
